module.exports = "\n<div>\n    <checkbox-group :value.sync=\"selection\"\n                    type=\"success\">\n        <checkbox-btn :value=\"value.slug\"\n                      :class=\"'-' + value.slug\"\n                      v-for=\"value of filter.values\">\n            {{ value.label }}\n        </checkbox-btn>\n    </checkbox-group>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/EnumFilter.vue
// module id = 492
// module chunks = 0